import { create } from 'zustand';
import api from '../utils/api';
import { User, UserState } from '../types/user';
import { getErrorMessage } from '../utils/error';

export const useUserStore = create<UserState>((set) => ({
  user: null,
  loading: false,
  error: null,

  fetchUser: async () => {
    set({ loading: true, error: null });
    try {
      const response = await api.get('/users/profile');
      set({ user: response.data, loading: false });
    } catch (err: unknown) {
      set({ error: getErrorMessage(err), loading: false });
    }
  },

  setUser: (user: User | null) => set({ user }),
  clearUser: () => set({ user: null, error: null }),
}));
